// 재무포털(fa) 백엔드 API 헬퍼 — 같은 도메인의 /api/* 를 그대로 재사용
import { currentCompany } from './company.js'

// 요청마다 지금 보고 있는 회사를 알려 준다. 주소에서 읽으므로 탭마다 다를 수 있고,
// 그래서 다른 탭에서 저장해도 엉뚱한 회사에 들어가지 않는다.
const 회사헤더 = () => ({ 'X-Company': currentCompany() })

async function req(method, url, body) {
  const res = await fetch(url, {
    method,
    headers: body ? { 'Content-Type': 'application/json', ...회사헤더() } : 회사헤더(),
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
  })
  let data = null
  try { data = await res.json() } catch {}
  if (!res.ok) {
    const msg = data?.error || `${res.status} ${res.statusText}`
    const err = new Error(msg)
    err.status = res.status
    throw err
  }
  return data
}

// 파일 동반 전송 — 본문 JSON은 payload 필드에, 파일은 files 필드에 담는다
async function upload(url, payload, files) {
  const fd = new FormData()
  fd.append('payload', JSON.stringify(payload ?? {}))
  for (const f of files ?? []) fd.append('files', f)
  const res = await fetch(url, { method: 'POST', body: fd, credentials: 'same-origin',
    headers: 회사헤더() })
  let data = null
  try { data = await res.json() } catch {}
  if (!res.ok) {
    const err = new Error(data?.error || `${res.status} ${res.statusText}`)
    err.status = res.status
    throw err
  }
  return data
}

// 파일 내려받기 — 서버가 정한 파일명(Content-Disposition)을 그대로 쓴다
async function download(url) {
  const res = await fetch(url, { credentials: 'same-origin', headers: 회사헤더() })
  if (!res.ok) {
    let msg = `${res.status} ${res.statusText}`
    try { msg = (await res.json())?.error || msg } catch {}
    const err = new Error(msg)
    err.status = res.status
    throw err
  }
  const cd = res.headers.get('Content-Disposition') || ''
  const star = /filename\*=UTF-8''([^;]+)/i.exec(cd)
  const plain = /filename="?([^";]+)"?/i.exec(cd)
  const name = star ? decodeURIComponent(star[1]) : (plain ? plain[1] : 'download')
  const blob = await res.blob()
  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(href), 1000)
}

export const portal = {
  get: (url) => req('GET', url),
  download,
  post: (url, body) => req('POST', url, body ?? {}),
  put: (url, body) => req('PUT', url, body ?? {}),
  del: (url) => req('DELETE', url),
  upload,
}
